import { Outlet } from 'react-router-dom';
import MapScreen from 'screens/mapScreen/MapScreen';

export default function MapContainerScreen({ precarga }) {
    return (
        <>
            <Outlet />
            <MapScreen precarga={precarga} />
        </>
      );}
